export enum AccountReceivableStatuses {
  RECEIVED = 'RECEIVED',
  ADVISED_UNMATCHED = 'ADVISED_UNMATCHED',
  ADVISED_MATCHED = 'ADVISED_MATCHED',
  PROCESSED = 'PROCESSED',
}

export default AccountReceivableStatuses;
export type VerifyAccountReceivableStatuses = Utils.VerifyExtends<
  Model.Enum.AccountReceivableStatuses,
  Utils.ValueOf<typeof AccountReceivableStatuses>
>;
